import React, { useEffect, useState, useContext } from "react";
import { useLocation, useNavigate, useParams, useOutletContext } from 'react-router-dom';
import { useAlert } from 'react-alert'
import CenteredLoadingIcon from "../../common_components/CenteredLoadingIcon";

// Api Calls
import MissionAPI from "../../../api/api_calls/MissionAPI";

function AudienceOptionsCard(props) {

    const navigate = useNavigate();
    const alert = useAlert();
    const { missionId } = useParams()

    const [loadingMission, setLoadingMission] = useState(true);
    const [requireReview, setRequireReview] = useState(false);
    const [viewUserWallets, setViewUserWallets] = useState(false);
    const [isInterview, setIsInterview] = useState(false);


    // Load the mission details and initial state
    useEffect(() => {
        async function getMissionDetails() {
            const result = await MissionAPI.show(missionId, navigate);

            if (result.success) {
                setRequireReview(result.mission.requires_researcher_review)
                setViewUserWallets(result.mission.view_user_wallets)
                setIsInterview(result.mission.intended_mission_type === "interview")
                setLoadingMission(false);
            } else {
                alert.show(result.error, { type: 'error' })
            }
        }
        getMissionDetails();
    }, []);

    // Toggle the requires review status when the checkbox is clicked
    function toggleRequiresReview() {
        async function updateRequiresReview(status) {
            const result = await MissionAPI.updateRequiresReview(missionId, status, navigate);

            if (result.success) {
                props.updatePrice();
            } else {
                setRequireReview(!status);
                alert.show(result.error, { type: 'error' })
            }
        }

        const newStatus = !requireReview;
        setRequireReview(newStatus);
        updateRequiresReview(newStatus);
    }

    function toggleViewUserWallets() {
        async function updateViewUserWallets(status) {
            const result = await MissionAPI.updateViewUserWallets(missionId, status, navigate);

            if (result.success) {
                props.updatePrice();
            } else {
                setViewUserWallets(!status);
                alert.show(result.error, { type: 'error' })
            }
        }

        const newStatus = !viewUserWallets;
        setViewUserWallets(newStatus);
        updateViewUserWallets(newStatus);
    }


    return (
        <div className="audience-requirements-card">
            {loadingMission ? <CenteredLoadingIcon /> :

                <div className="empty-audience-screener-card">
                    <div className="audience-requirements-card-title-and-subtitle">
                        <div className="audience-requirements-card-title">
                            Options
                        </div>
                        <div className="left-padding-12 options-checkbox-container">
                            {isInterview &&
                                <OptionCheckboxAndLabel
                                    value={requireReview}
                                    label="I want to review users who apply. This may significantly slow down your project, and will add to your price. You'll see all users who have applied, and have to manually approve them before they can participate."
                                    toggleCheckBox={toggleRequiresReview}
                                />
                            }
                            <OptionCheckboxAndLabel
                                value={viewUserWallets}
                                label="I want to view users' verified wallet addresses. This will slightly increase your price."
                                toggleCheckBox={toggleViewUserWallets}
                            />
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}

function OptionCheckboxAndLabel(props) {
    return (
        <div className="user-type-checkbox-container">
            <input className="user-type-checkbox-color"
                id={props.label}
                type='checkbox'
                name={props.label}
                onChange={props.toggleCheckBox}
                checked={props.value}
            />
            <label className="extra-padding gray-text" htmlFor={props.label}>
                {props.label}
            </label>
        </div>
    )
}



export default AudienceOptionsCard;
